const _SELF_REGEX_ = /^(?:[1-9])$/
export class Orde {
  private value: number

  constructor (id: number) {
    if (!_SELF_REGEX_.test(id.toString())) {
      throw new TypeError('Wrong format for Order')
    }
    this.value = id
  }

  orde (): number {
    return this.value
  }
}
